import { getValidToken } from '../utils/tokenUtils';
import { apiRequest } from './apiHelpers';

export const fetchContractsByTester = async (email, organisationId) => {
  const token = await getValidToken();
  const res = await fetch(`/api/serviceorder/tester?email=${encodeURIComponent(email)}&organisationId=${encodeURIComponent(organisationId)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunde inte hämta testerens kontrakt.');
  return res.json();
};

// contracts: [{ contractId, serviceNowId }]
export const createServiceOrder = async (organisationId, contracts, testerEmails, tpvIssueKey, testingOrganisationId = null) => {
  const token = await getValidToken();
  const payload = {
    organisationId,
    contracts,
    testerEmails,
    tpvIssueKey: tpvIssueKey || null,
    testingOrganisationId: testingOrganisationId || null,
  };

  const res = await fetch('/api/serviceorder', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    const err = new Error(errorData?.message || 'Något gick fel vid skapandet av beställningen.');
    err.status = res.status;
    throw err;
  }

  return res.json();
};

export const fetchSourceSystemOptions = async () => {
  const token = await getValidToken();
  const res = await fetch('/api/serviceorder/source-systems', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunde inte hämta källsystem.');
  return res.json();
};

export const fetchServiceOrderGroups = async (organisationId = null) => {
  const query = organisationId ? `?organisationId=${encodeURIComponent(organisationId)}` : '';
  const data = await apiRequest(`/api/serviceorder/groups${query}`);
  return Array.isArray(data) ? data : [];
};

export const fetchServiceOrderGroup = (orderGroupId) =>
  apiRequest(`/api/serviceorder/group?orderGroupId=${encodeURIComponent(orderGroupId)}`);

export const updateServiceOrderGroup = (
  { orderGroupId, contracts, testerEmails, sourceSystem, serviceProvider }
) =>
  apiRequest('/api/serviceorder/group', {
    method: 'PUT',
    body: JSON.stringify({
      orderGroupId,
      contracts,
      testerEmails,
      sourceSystem,
      serviceProvider: serviceProvider || null,
    }),
  });

export const deleteServiceOrderGroup = (orderGroupId) =>
  apiRequest(
    `/api/serviceorder/group?orderGroupId=${encodeURIComponent(orderGroupId)}`,
    { method: 'DELETE' }
  );
